import React from "react";

// Neon-bordered dark pills for A-E options (anti-Kahoot)
const styles = {
  A: { border: "border-cyan-500/50 hover:border-cyan-400", text: "text-cyan-300", glow: "hover:shadow-[0_0_24px_-4px_rgba(5,217,232,0.55)]", ring: "focus:ring-cyan-400/60" },
  B: { border: "border-pink-500/50 hover:border-pink-400", text: "text-pink-300", glow: "hover:shadow-[0_0_24px_-4px_rgba(255,42,109,0.55)]", ring: "focus:ring-pink-400/60" },
  C: { border: "border-yellow-500/50 hover:border-yellow-400", text: "text-yellow-300", glow: "hover:shadow-[0_0_24px_-4px_rgba(209,255,39,0.55)]", ring: "focus:ring-yellow-400/60" },
  D: { border: "border-violet-500/50 hover:border-violet-400", text: "text-violet-300", glow: "hover:shadow-[0_0_24px_-4px_rgba(139,92,246,0.55)]", ring: "focus:ring-violet-400/60" },
  E: { border: "border-emerald-500/50 hover:border-emerald-400", text: "text-emerald-300", glow: "hover:shadow-[0_0_24px_-4px_rgba(16,185,129,0.55)]", ring: "focus:ring-emerald-400/60" },
};

export function OptionButton({ letter, children, onClick, disabled, selected, correct, showResult, testId }) {
  const s = styles[letter];
  let stateCls = `${s.border} ${s.text} ${s.glow}`;
  if (showResult) {
    if (correct) stateCls = "border-emerald-400 text-emerald-300 shadow-[0_0_28px_-4px_rgba(16,185,129,0.7)] bg-emerald-500/10";
    else if (selected) stateCls = "border-red-500 text-red-300 bg-red-500/10";
    else stateCls = "border-white/10 text-zinc-500 opacity-60";
  } else if (selected) {
    stateCls = `${s.border.replace("/50","")} ${s.text} bg-white/5 shadow-[0_0_28px_-4px_rgba(255,255,255,0.25)]`;
  }
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={`option-pill w-full min-h-[72px] rounded-2xl border-2 bg-zinc-950/70 px-5 py-4 text-left flex items-center gap-4 focus:outline-none focus:ring-4 ${s.ring} disabled:cursor-not-allowed ${stateCls}`}
    >
      <span className="font-heading font-bold text-2xl w-10 h-10 rounded-full border border-current flex items-center justify-center shrink-0">
        {letter}
      </span>
      <span className="font-body text-base sm:text-lg leading-snug text-white">{children}</span>
      {showResult && correct && <span className="ml-auto text-emerald-300 font-heading">✓ DOĞRU</span>}
      {showResult && selected && !correct && <span className="ml-auto text-red-300 font-heading">✕ YANLIŞ</span>}
    </button>
  );
}
